// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__llDvh","name":"ConsentHeader_name__2Aixe","birthday":"ConsentHeader_birthday__1SM7k","skeleton":"ConsentHeader_skeleton__2Jl9m"};